<template>
  <div class="grid mx-auto max-w-xl md:max-w-none grid-cols-3 md:grid-cols-4 gap-4">
    <div v-for="ip in filteredIPs" :key="ip.name">
      <IPCard :name="ip.name" :description="ip.mini_desc" />
    </div>
  </div>
</template>

<script>
import IPCard from '@/components/IPCard.vue'
import ipData from '@/assets/ip.json'

export default {
  name: 'IpGrid',
  props: {
    search: String,
  },
  components: {
    IPCard
  },
  data() {
    return {
      ipcores: Object.values(ipData),
    }
  },
  computed: {
    filteredIPs() {
      if (!this.search) return this.ipcores;
      const searchLower = this.search.toLowerCase();
      return this.ipcores.filter(ip =>
        ip.name.toLowerCase().includes(searchLower) ||
        ip.mini_desc.toLowerCase().includes(searchLower) ||
        ip.category.toLowerCase().includes(searchLower)
      );
    }
  },
}
</script>
